import { LABELS } from '@/constants/common/message.constants'

import { type MonthlyTourReportAdditionExEntity } from '../..'

/**
 * 税区分の種別
 */
export type TaxType = NonNullable<
  MonthlyTourReportAdditionExEntity['managementPriceTaxType']
>

export const TAX_TYPE = {
  /** 課税 */
  TAXABLE: 'TAXABLE',
  /** 非課税 */
  NON_TAXABLE: 'NON_TAXABLE'
} as const satisfies Record<TaxType, TaxType>

export const TAX_TYPE_LABEL = {
  [TAX_TYPE.TAXABLE]: LABELS.TAXATION,
  [TAX_TYPE.NON_TAXABLE]: LABELS.NON_TAXATION
} as const satisfies Record<TaxType, string>
